import React from "react";
import sortBy from "lodash/sortBy";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";

import Button from "@mui/material/Button";
import { Add } from '@vedmarket/ui-kit';
import { ContentCopy as ContentCopyIcon } from '@vedmarket/ui-kit';

import SummaryCalculator from '../../../../common/summaryCalculator'
import { getCalculationExtraInfo } from '../../../../common/summaryCalculator/calculation-extra-info'
import {
  CALC_ID,
  useCloneCalculationMutation,
  useInvoicesData,
  useGetOrderSummaryByIdQuery,
  useGetOrderSummaryInvoicesByIdQuery,
  useOrder,
  useResetOrderId,
  useSummary,
  useSummaryCustoms,
  useCurrentRoute,
  useSummaryCompleted,
  useDeclarationsByOrderIdQuery, useCertCodes,
} from "../../../../../api/calc";
import {ROUTES} from "../../../../../config/constants";
import {useGetCalcIdFromRoute} from "../../../../../utils/hooks";

import './right-panel.scss';


const RightPanel = ({ demoCurrentStepCompleted, demoCurrentStepIndex, topActions }: CalculatorRightPanelProps) => {

  const order = useOrder();
  const invoices = useInvoicesData();
  const sortedInvoices = sortBy(invoices, 'id');
  const summaryOrder = useSummary();
  const summaryCustoms = useSummaryCustoms();
  const summaryDelivery = useCurrentRoute();
  const summaryCompleted = useSummaryCompleted()
  const summaryCertification = useCertCodes()

  const orderId = useGetCalcIdFromRoute()

  const { data: declarations } = useDeclarationsByOrderIdQuery(orderId, { skip: !orderId })
  const { data: summaryInfo } = useGetOrderSummaryByIdQuery(orderId, { skip: !orderId })
  const { data: summaryInvoices } = useGetOrderSummaryInvoicesByIdQuery(orderId, { skip: !orderId })

  const [ cloneOrder ] = useCloneCalculationMutation()

  const navigate = useNavigate();

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const calculationData: CalculationExtraInfoData = {
    order,
    packagingSummary: summaryOrder,
    summaryInfo,
    summaryInvoices,
    invoices: sortedInvoices,
    route: summaryDelivery,
    declarations,
    bankCommissions: order.bankCommissions,
    certification: summaryCertification,
    extraServices: order.userExtraServices,
  }

  const openNewCalculation = () => {

    navigate(`/${ROUTES.CABINET}/${ROUTES.CALCULATOR}`, { replace: true })
    localStorage.removeItem(CALC_ID);
    navigate(0);
    // @ts-ignore
    dispatch(useResetOrderId(''));
  }

  const cloneCalculation = () => cloneOrder(orderId)?.then((data) => {
    // @ts-ignore
    const newNumber = data?.data?.num;

    if (newNumber) {
      navigate(`/${ROUTES.CABINET}/${ROUTES.CALCULATOR}/${newNumber}`);
    }}
  )

  return (
    <>
      <div className='right-panel-buttons'>
        <Button
          variant='outlined'
          sx={{ width: orderId ? '132px': '100%', marginBottom: 4, fontSize: 15, fontWeight: 500, letterSpacing: '0.46px' }}
          onClick={openNewCalculation}
          startIcon={<Add />}
          fullWidth={!orderId}
        >{t('calc__text__rightPanel__newCalculation')}</Button>
        {orderId && <Button
          variant='outlined'
          sx={{ width: '204px', marginBottom: 4, fontSize: 15, fontWeight: 500, letterSpacing: '0.46px' }}
          onClick={cloneCalculation}
          startIcon={<ContentCopyIcon />}
        >{t('actions__text__copy')}</Button>}
      </div>
      <div className='right-panel'>
        {topActions}
        <SummaryCalculator
          calculation={{
            order,
            invoices: sortedInvoices,
            summaryOrder,
            summaryCustoms,
            summaryDelivery,
            summaryCompleted,
            summaryCertification,
            declarations,
            extraInfo: getCalculationExtraInfo({
              calculation: calculationData,
              translate: t,
            }),
          }}
          presentation={{
            showSubmissionStatus: true,
          }}
          demoCurrentStepCompleted={demoCurrentStepCompleted}
          demoCurrentStepIndex={demoCurrentStepIndex}
        />
      </div>
    </>
  )
}

export default RightPanel
